if (window.jQuery) {
    (function ($, sitenav) {
        "use strict";
        sitenav = sitenav || (window.sitenav = {});
        sitenav.App = sitenav.App || (sitenav.App = {});

        sitenav.App.ReturnUrlBuilder = {
            appendReturnUrl: function () {
                var currentUrl = location.href;

                $(".append-return-url").each(function (idx, data) {
                    var href = $(data).attr("href");

                    const signOutLink = $(data).data("signout") ? $(data).data("signout").toLowerCase() === "true" : false;
                    const shouldAppend = !(signOutLink && href.indexOf(location.host) > -1);
                    const returnUrlKey = $(data).data("returnUrlKey") ? $(data).data("returnUrlKey") : "ret";

                    if (!shouldAppend) return;
                    href += href.indexOf("?") > -1 ? "&" : "?";

                    // Add memberdriver
                    if (!signOutLink) {
                        href += `memberdriver=main_driver&`;
                    }

                    // if its seller.carsalesnetwork then we always want to return to the homepage of the hero site
                    if (currentUrl.indexOf("seller.carsalesnetwork") > -1) {
                        let heroSiteDomain = $(data).data("hero-site-domain");

                        if (heroSiteDomain.indexOf("http://") === -1) {
                            heroSiteDomain = `http://${heroSiteDomain}`;
                        }
                        href += `src=sitenav&${returnUrlKey}=${encodeURIComponent(heroSiteDomain)}`;
                    } else {
                        // strip utm params if it's signout - RTL-6435
                        if (signOutLink) {
                            currentUrl = removeUrlParameter(currentUrl, "utm_source");
                            currentUrl = removeUrlParameter(currentUrl, "utm_campaign");
                            currentUrl = removeUrlParameter(currentUrl, "utm_medium");
                            currentUrl = removeUrlParameter(currentUrl, "utm_term");
                            currentUrl = removeUrlParameter(currentUrl, "utm_content");
                        }
                        href += `src=sitenav&${returnUrlKey}=${encodeURIComponent(currentUrl)}`;
                    }

                    const tracking = $(data).data("tracking");
                    if (tracking && tracking.length > 0) {
                        href += `&${tracking}`;
                    }

                    $(data).attr("href", href);
                });

                function removeUrlParameter(url, parameter) {
                    var urlParts = url.split('?');

                    if (urlParts.length >= 2) {
                        // Get first part, and remove from array
                        var urlBase = urlParts.shift();

                        // Join it back up
                        var queryString = urlParts.join('?');

                        var prefix = encodeURIComponent(parameter) + '=';
                        var parts = queryString.split(/[&;]/g);

                        // Reverse iteration as may be destructive
                        for (var i = parts.length; i-- > 0;) {
                            // Idiom for string.startsWith
                            if (parts[i].lastIndexOf(prefix, 0) !== -1) {
                                parts.splice(i, 1);
                            }
                        }

                        url = urlBase + '?' + parts.join('&');
                    }

                    return url;
                }
            }
        };

        sitenav.App.ReturnUrlBuilder.appendReturnUrl();
    }(jQuery, window.sitenav));
}